(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9FaVK", function(module, exports) {

$parcel$export(module.exports, "events", function () { return events; });
function toJqueryInstance(selector) {
    var $ = jQuery;
    if (!selector) return $();
    else if (selector instanceof $) return selector;
    else if (typeof selector === "string") return $("#" + selector);
    else return $(selector);
}
var UIEvents = function UIEvents(wrap, events, callback) {
    var $wrap = toJqueryInstance(wrap);
    if ($wrap && $wrap.length) {
        var bind = function bind() {
            var $el = jQuery(this), handler = $el.attr("data-event") || $el.attr("@event"), type = $el.attr("data-event-type") || $el.attr("@type"), event = {
                handler: null,
                type: null,
                data: {}
            }, obj;
            if (handler.indexOf("{") + 1 > 0 && handler.lastIndexOf("}")) {
                obj = eval("(" + handler + ")");
                event.handler = obj.handler || obj.action;
                event.type = obj.type;
                event.data = obj.data;
            } else {
                event.handler = handler;
                event.type = type;
            }
            if (events[event.handler]) $el.on(event.type || "click", event.data, function(e) {
                events[event.handler].call(events, this, e);
            }).removeAttr("data-event data-event-type @event");
        };
        $wrap.find("[data-event]").each(bind);
        $wrap.find('*:attrStartsWith("@event")').each(bind);
        callback && callback();
    }
};
var events = {
    bind: UIEvents
};

});


var $9FaVK = parcelRequire("9FaVK");
var $d76b04a879df726c$var$App = function App(config) {
    config = config || {};
    var _this = this;
    this.elms = {};
    this.elms.$wrap = jQuery("#" + config.wrapId);
    this.elms.$list = this.elms.$wrap.find("UL");
    this.elms.$list.html("");
    var duration = config.duration;
    var create = {
        item: function item(text, type) {
            var factory = {
                text: function text() {
                    switch(type){
                        case "danger":
                            return "The operation has encountered an error.";
                        case "success":
                        case "warning":
                        case "info":
                        case "message":
                        default:
                            return "The operation was successful.";
                    }
                }
            };
            var html = "";
            html += '<li class="<!--type-->">';
            html += "<span>";
            html += "<!--message--><span class='toast__progress'>";
            html += "<span style='animation-duration: " + (duration + 300) / 1000 + "s' class='toast__progress-bar'>";
            html += "</span>";
            html += "</span>";
            html += "</span>";
            html += "</li>";
            html = html.replace(/<!--type-->/, type || "default").replace(/<!--message-->/, text || factory.text());
            return {
                jq: jQuery(html),
                html: html
            };
        },
        wrap: function wrap() {
            var html = "<div id='toast' class=\"toast\"><ul></ul></div>";
            return {
                jq: jQuery(html),
                html: html
            };
        }
    };
    var close = function close(toast) {
        var $toast = jQuery(toast);
    };
    var hide = function hide() {
        var $toast = _this.$toast;
        setTimeout(function() {
            $toast.removeClass("show");
        }, duration + 300);
        setTimeout(function() {
            $toast.remove();
        }, duration + 600);
        $toast.on("click", function() {
            $toast.removeClass("show");
            setTimeout(function() {
                $toast.remove();
            }, 300);
        });
    };
    this.hide = function(toast) {
        toast.removeClass("show");
        setTimeout(function() {
            toast.remove();
        }, 300);
    };
    var show = function show($toast, autoHide) {
        var width = _this.elms.$wrap.outerWidth(true);
        $toast.css("width", width);
        setTimeout(function() {
            $toast.addClass("show");
        }, 300);
        _this.$toast = $toast;
        if (autoHide !== false) hide(); // Automatically hide toast item
    };
    var append = function append(message, type, callback, autoHide) {
        var $toast = create.item(message, type).jq;
        _this.elms.$list.append($toast);
        show($toast, autoHide);
        callback && callback();
        return $toast;
    };
    this.success = function(message, callback, autoHide) {
        return append(message, "success", callback, autoHide);
    };
    this.danger = function(message, callback, autoHide) {
        return append(message, "danger", callback, autoHide);
    };
    this.warning = function(message, callback, autoHide) {
        return append(message, "warning", callback, autoHide);
    };
    this.info = function(message, callback, autoHide) {
        return append(message, "info", callback, autoHide);
    };
    this.message = function(message, callback, autoHide) {
        return append(message, "warning", callback, autoHide);
    };
    this.progress = function(message, callback, autoHide) {
        return append(message, "warning progress", callback, autoHide);
    };
    this.init = function() {
        if (this.elms.$wrap && !this.elms.$wrap.length) {
            this.elms.$wrap = create.wrap().jq;
            jQuery(document.body).append(this.elms.$wrap);
            this.elms.$list = this.elms.$wrap.find("UL");
        }
        return this;
    };
    return this;
};
var $d76b04a879df726c$export$b410431fab84fa58 = new $d76b04a879df726c$var$App({
    wrapId: "toast",
    duration: 5000
}).init();


function $98a1b70bef71be3b$export$abc3ce5761c193(input, target, complete) {
    var $target = jQuery(target);
    if (input && target) {
        if (input.files && input.files.length) {
            var reader = new FileReader(), src = null, img = new Image(), data = {};
            reader.onload = function(e) {
                src = e.target.result;
                if (target) $target.attr("src", src);
                img.src = src;
                img.onload = function() {
                    data.width = img.width;
                    data.height = img.height;
                    data.src = img.src;
                    complete && complete(data);
                };
            };
            reader.readAsDataURL(input.files[0]);
        }
    }
}


var $01979c0364bb33ee$var$ChangeAvatarApp = function ChangeAvatarApp(config, $) {
    var app = this;
    var allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg"
    ];
    var ajax = null;
    app.elms = {};
    app.elms.$wrap = $(config.wrap);
    app.elms.$img = app.elms.$wrap.find("img");
    app.elms.$file = app.elms.$wrap.find("input:file");
    app.elms.$btn = app.elms.$wrap.find("button:submit");
    app.fileUploadChange = function(el, e) {
        var maxSize = el.getAttribute("data-max-size"); // 2MB in bytes
        if (el.files.length > 0) {
            var file = el.files[0];
            if (!allowedTypes.includes(file.type)) {
                (0, $d76b04a879df726c$export$b410431fab84fa58).danger("Only PNG, JPG, and JPEG files are allowed.");
                e.preventDefault();
                return;
            }
            if (file.size > maxSize) {
                (0, $d76b04a879df726c$export$b410431fab84fa58).danger("Max size is less than 2MB");
                e.preventDefault();
                return;
            }
        }
        (0, $98a1b70bef71be3b$export$abc3ce5761c193)(el, app.elms.$img);
    };
    app.saveAvatar = function(form, e) {
        e.preventDefault();
        if (ajax) return;
        var data = new FormData();
        var files = app.elms.$file[0].files;
        if (files.length > 0) data.append("avatar", files[0]);
        else {
            (0, $d76b04a879df726c$export$b410431fab84fa58).warning("No file chose");
            return;
        }
        ajax = $.ajax({
            url: form.getAttribute("action"),
            type: form.getAttribute("method"),
            data: data,
            processData: false,
            contentType: false,
            beforeSend: function beforeSend() {
                app.elms.$btn.addClass("progressing");
            },
            success: function success(res) {
                (0, $d76b04a879df726c$export$b410431fab84fa58).success();
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                (0, $d76b04a879df726c$export$b410431fab84fa58).error("Unexpected error");
                console.error("Error:", textStatus, errorThrown);
            },
            complete: function complete() {
                app.elms.$btn.removeClass("progressing");
                ajax = null;
            }
        });
    };
    app.init = function() {
        (0, $9FaVK.events).bind(app.elms.$wrap, app);
        return this;
    };
};
addEventListener("DOMContentLoaded", function() {
    new $01979c0364bb33ee$var$ChangeAvatarApp({
        wrap: ".wwAr"
    }, jQuery).init();
});

})();
//# sourceMappingURL=index.js.map
